export default __webpack_public_path__ + "static/media/rooberttrial-light-webfont.d8c1e43c.ttf";